import { types } from "mobx-state-tree";

const UserPermission = types.model('UserPermission', {
  permission: types.string,
  permitted: types.optional(types.boolean, false),
  componentCode: types.string,
  component: types.string,
  permissionDisplayName: types.string,
});

export default UserPermission;